module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hant_2-da50546e47665a91ad8978d3422baad5.jpg";